<script>
	import {External, M} from '../../../../../external';
	import {getAttachmentName} from "../../../../../CRM/Popups/messages/common";

	export let data = { message: { id: -1, type: '', channel: '', attachments: [], body: '' } },
		contact;

	const id = data.message?.id || -1;
	const type = data.message?.type || '';
	const channel = data.message?.channel || '';
	const attachments = data.message?.attachments || [];
	const body = data.message?.body || '';

	const clickHandler = () => {
		switch (type) {
			case 'AUTOMATION':
				External.CPanel.goToUrl('/me/crm/marketing/automation?id=' + id);
				break;
			case 'CAMPAIGN':
				External.CPanel.goToUrl('/me/crm/marketing/campaign/message/overview?id=' + id);
				break;
		}
	};

</script>

<style>
	.whatsapp-image-attachment {
		width: 215px !important;
		min-width: 120px !important;
		max-width: 216px !important;
	}

	.whatsapp-video-attachment {
		width: 215px !important;
		min-width: 120px !important;
	}

	.whatsapp-audio-attachment {
		width: 215px !important;
		min-width: 120px !important;
	}
</style>

<div class="flex flex-col">
	{#if channel === External.CRM_MESSAGE_CHANNEL.WHATSAPP && attachments}
		<div class="flex-none">
			{#each attachments as attachment}
				<a href='{attachment.url}' target='_blank' rel='noreferrer'>
					{#if attachment.type?.startsWith("video")}
						<video class='whatsapp-attachment whatsapp-video-attachment' controls>
							<track kind='captions' src=''>
							<source src='{attachment.url}' type='{attachment.type}'>
							{M.VIEW_ATTACHMENT}
						</video>
					{:else if attachment.type?.startsWith("audio")}
						<audio class='whatsapp-attachment whatsapp-audio-attachment' controls>
							<source src='{attachment.url}' type='{attachment.type}'>
							{M.VIEW_ATTACHMENT}
						</audio>
					{:else}
						<img alt='' class='whatsapp-attachment whatsapp-image-attachment' src='{attachment.url}'/>
					{/if}
				</a>
			{/each}
		</div>
	{/if}

	{#if body}
		<div class="flex-none">
			{#if type === External.CRM_MESSAGE_TYPE.INDIVIDUAL || type === External.CRM_MESSAGE_TYPE.INDIVIDUAL_SCHEDULED}
				{body}
			{:else}
				<a class='blue-text' on:click={clickHandler}>'{body}'</a>
			{/if}
		</div>
	{/if}

	{#if channel === External.CRM_MESSAGE_CHANNEL.VOICE && attachments}
		{#each attachments as attachment}
			<div class="flex-none">
				<a href='{attachment.url}' class='text-link blue-text mt-10' style='display: block;' target='_blank' rel='noreferrer'>
					<span class="flex flex-row">
						<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368">
							<path
								d="M560-131v-82q90-26 145-100t55-168q0-94-55-168T560-749v-82q124 28 202 125.5T840-481q0 127-78 224.5T560-131ZM120-360v-240h160l200-200v640L280-360H120Zm440 40v-322q47 22 73.5 66t26.5 96q0 51-26.5 94.5T560-320ZM400-606l-86 86H200v80h114l86 86v-252ZM300-480Z"/>
						</svg>
						<span class='f-left ml-10'>{getAttachmentName(attachment)}</span>
					</span>
				</a>
			</div>
		{/each}
	{/if}

	<slot/>

</div>
